import { render, staticRenderFns } from "./my-social-share-popup.vue?vue&type=template&id=b96d27f8&scoped=true&"
import script from "./my-social-share-popup.vue?vue&type=script&lang=js&"
export * from "./my-social-share-popup.vue?vue&type=script&lang=js&"
import style0 from "./my-social-share-popup.vue?vue&type=style&index=0&id=b96d27f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96d27f8",
  null
  
)

export default component.exports